import type { BilingualText } from "@core/types";
import { resolveBilingualText as text } from "./bilingualText";
import type { IncludeItem } from "./useIncludesField";

// GATE-01-A (agent-logs/runs/2026-09-11-spec-219-offers/evidence/
// human-resolution-gate-01-dup-and-format.json): la conversión entre la
// lista persistida de `includes` ({ text: BilingualText, sortOrder }[]) y el
// par de funciones que la editan en el formulario ({ textEs, textEn }[]) era
// el mismo código palabra por palabra en benefits/BenefitsScreen.tsx y
// offers/OffersScreen.tsx (`defaultsFor` y `buildInput`). Pura
// transformación de datos, sin JSX ni permisos de por medio — extracción sin
// cambio de comportamiento: mismo orden, mismos campos opcionales.
export function includesToFormValues(
  includes: { text?: BilingualText; sortOrder?: number }[] | undefined,
): IncludeItem[] {
  return (includes ?? [])
    .slice()
    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
    .map((item) => ({
      textEs: text(item.text, "es"),
      textEn: text(item.text, "en"),
    }));
}

export function includesToInput(
  items: IncludeItem[],
): { sortOrder: number; text: BilingualText }[] {
  return items.map((item, index) => ({
    sortOrder: index,
    text: {
      es: item.textEs,
      ...(item.textEn ? { en: item.textEn } : {}),
    },
  }));
}
